export enum UserRole {
  support = 'support',
  admin = 'admin',
  fleetAdmin = 'fleetAdmin',
  fleetManager = 'fleetManager',
  fleetViewer = 'fleetViewer',
}

export const ROLE_MAP: { [key: string]: string } = {
  fleetViewer: 'Fleet Viewer',
  fleetManager: 'Fleet Manager',
  fleetAdmin: 'Fleet Admin',
  support: 'Support Engineer',
  admin: 'System Admin',
};
